import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

/**
 * "분석 Report" 탭의 "보고서 발행"(PDF) — 현재 화면에 렌더링된 그대로(필터로 숨긴 UT
 * 항목은 제외된 상태 그대로)를 캡쳐해 PDF로 저장한다. 한글 폰트를 PDF에 임베드해야 하는
 * jsPDF의 벡터 텍스트 방식 대신, 브라우저가 이미 그린 DOM을 이미지로 캡쳐해 페이지 폭에
 * 맞춰 여러 장에 걸쳐 배치하는 방식을 쓴다(내용이 한 페이지보다 길면 자동으로 다음 장에
 * 이어서 배치).
 *
 * ref/frontend/features/UtMatrixRpt/utils/exportPdf.ts 그대로 옮겼다.
 */
export async function exportUtMatrixRptPdf(rptNm: string, element: HTMLElement): Promise<void> {
  const canvas = await html2canvas(element, {
    scale: 2,
    backgroundColor: '#ffffff',
    useCORS: true,
    // 발행 버튼/저장 버튼 영역은 결과물에 남기지 않는다
    ignoreElements: (el) => el.classList.contains('section-actions'),
  });

  const pdf = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const imgW = pageW;
  const imgH = (canvas.height * imgW) / canvas.width;
  const imgData = canvas.toDataURL('image/png');

  let heightLeft = imgH;
  let position = 0;
  pdf.addImage(imgData, 'PNG', 0, position, imgW, imgH);
  heightLeft -= pageH;
  while (heightLeft > 0) {
    position -= pageH;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, imgW, imgH);
    heightLeft -= pageH;
  }

  pdf.save(`${rptNm || 'UT_Matrix_Rpt'}.pdf`);
}
